import { PropsWithChildren } from 'react'
import { Box as MuiBox, SxProps, Theme } from '@mui/material'
import clsx from 'clsx'

type Size = 'small' | 'medium' | 'large'

interface SizingContainerProps {
  size?: Size
  minWidth?: number
  className?: string
}

const sx: Record<Size, SxProps<Theme>> = {
  small: {
    width: {
      xs: '100%',
      sm: '50%',
      md: '33%',
    },
    flexBasis: (theme) => ({
      xs: '100%',
      sm: `calc(50% - ${theme.spacing()})`,
      md: `calc((100% - ${theme.spacing(2)}) / 3)`,
    }),
  },
  medium: {
    width: {
      xs: '100%',
      sm: '50%',
    },
    flexBasis: (theme) => ({
      xs: '100%',
      sm: `calc(50% - ${theme.spacing()})`,
    }),
  },
  large: {
    width: '100%',
    flexBasis: '100%',
  },
}

export default function SizingContainer({
  size = 'large',
  minWidth = 120,
  children,
  className,
}: PropsWithChildren<SizingContainerProps>): JSX.Element {
  return (
    <MuiBox
      className={clsx('sizing-container', `sizing-container-${size}`, className)}
      sx={{ ...sx[size], minWidth }}
    >
      {children}
    </MuiBox>
  )
}
